import { NgModule } from '@angular/core';
import { FiInfoBannerComponent } from './fi-info-banner.component';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
    imports: [CommonModule, MatIconModule, MatButtonModule],
    declarations: [FiInfoBannerComponent],
    exports: [FiInfoBannerComponent],
})
export class FiInfoBannerModule {}
